/**
 * @fileoverview O idioma da tela, para quem precisa redesenhar quando ele muda:
 * as telas chamam i18n.t direto (sem o react-i18next), então só trocam de
 * idioma quando renderizam de novo.
 */

import { useEffect, useState } from "react";
import { i18n } from "../translate/i18n";

const useLanguage = () => {
  const [language, setLanguage] = useState(i18n.language);
  useEffect(() => {
    const update = (next) => setLanguage(next);
    i18n.on("languageChanged", update);
    return () => i18n.off("languageChanged", update);
  }, []);
  return language;
};

export default useLanguage;
